import { H3, Modal } from 'platform-components/common';
import { TEXT_MARKUP_TYPE, HEADER_TEXT_SIZE, TEXT_WEIGHT } from 'platform-components/constants';
import React from 'react';

import { NewYearModalTextProps } from '../types';

import './new-year-modal__header.scss';

interface Props extends NewYearModalTextProps {
    mix?: string;
}

export const NewYearModalHeader = ({ id, values, mix }: Props) => {
    return (
        <Modal.Header mix={mix}>
            <H3
                fixed
                id={id}
                size={HEADER_TEXT_SIZE.M}
                type={TEXT_MARKUP_TYPE.MARKDOWN}
                values={values}
                weight={TEXT_WEIGHT.M}
            />
        </Modal.Header>
    );
};
